import { ArrowForwardIos } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { Mousewheel, Scrollbar, FreeMode } from 'swiper/modules';
import { BaseSwiper, BaseSwiperContainer } from "./components/BaseSwiper/BaseSwiper.js";
import styles from "./DynamicSwiper.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DynamicSwiper({
  uniqueId,
  className,
  pagination,
  scrollbar,
  ...props
}) {
  const dynamicBullets = typeof pagination === 'object' ? pagination.dynamicBullets : !!scrollbar;
  return /*#__PURE__*/_jsx(BaseSwiperContainer, {
    className: classnames(className, styles.container, {
      [styles.withPagination]: !!pagination,
      [styles.withScrollbar]: !!scrollbar
    }),
    children: /*#__PURE__*/_jsx(BaseSwiper, {
      ...props,
      swiperProps: {
        modules: [Mousewheel, Scrollbar, FreeMode],
        slidesPerView: 'auto',
        navigation: {
          disabledClass: styles.disabled,
          prevEl: `.swiperPrev-${uniqueId}`,
          nextEl: `.swiperNext-${uniqueId}`
        },
        mousewheel: {
          enabled: true,
          forceToAxis: true
        },
        scrollbar: !!scrollbar && {
          draggable: true
        },
        pagination: (!!pagination || !!scrollbar) && {
          enabled: true,
          dynamicBullets,
          dynamicMainBullets: 3,
          clickable: true,
          el: `.${styles.paginationEl}`
        },
        freeMode: true
      },
      arrowsInside: true,
      children: /*#__PURE__*/_jsxs("div", {
        slot: "container-end",
        className: styles.controlContainer,
        children: [/*#__PURE__*/_jsx("div", {
          className: classnames(styles.navigationArrow, styles.prev, `swiperPrev-${uniqueId}`),
          children: /*#__PURE__*/_jsx(ArrowForwardIos, {
            className: styles.navigationIcon
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classnames(styles.paginationContainer, !!scrollbar && styles.onlyMobile, dynamicBullets && styles.dynamicBullets),
          children: /*#__PURE__*/_jsx("div", {
            className: styles.paginationEl
          })
        }), /*#__PURE__*/_jsx("div", {
          className: classnames(styles.navigationArrow, styles.next, `swiperNext-${uniqueId}`),
          children: /*#__PURE__*/_jsx(ArrowForwardIos, {
            className: styles.navigationIcon
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.prevFadeOut
        }), /*#__PURE__*/_jsx("div", {
          className: styles.nextFadeOut
        })]
      })
    })
  });
}